module.exports = __webpack_public_path__ + "img/manual_short.bf72e9d2.png";